// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as SiteIndexRouteImport } from './routes/_site/index'
import { Route as SiteSplatRouteImport } from './routes/_site/$'
import { Route as SiteAboutRouteImport } from './routes/_site/about'
import { Route as SiteContactRouteImport } from './routes/_site/contact'
import { Route as SiteDocsRouteImport } from './routes/_site/docs'
import { Route as SitePrivacyRouteImport } from './routes/_site/privacy'
import { Route as SiteComponentsIndexRouteImport } from './routes/_site/components/index'
import { Route as SiteComponentsCategoryRouteImport } from './routes/_site/components/$category'
import { Route as SiteDocsIndexRouteImport } from './routes/_site/docs/index'
import { Route as SiteDocsSplatRouteImport } from './routes/_site/docs/$'

const SiteRoute = SiteRouteImport.update({
            id: '/_site',getParentRoute: () => rootRouteImport
          })
const SiteIndexRoute = SiteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteRoute
          })
const SiteSplatRoute = SiteSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => SiteRoute
          })
const SiteAboutRoute = SiteAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => SiteRoute
          })
const SiteContactRoute = SiteContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => SiteRoute
          })
const SiteDocsRoute = SiteDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => SiteRoute
          })
const SitePrivacyRoute = SitePrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => SiteRoute
          })
const SiteComponentsIndexRoute = SiteComponentsIndexRouteImport.update({
            id: '/components/',path: '/components/',getParentRoute: () => SiteRoute
          })
const SiteComponentsCategoryRoute = SiteComponentsCategoryRouteImport.update({
            id: '/components/$category',path: '/components/$category',getParentRoute: () => SiteRoute
          })
const SiteDocsIndexRoute = SiteDocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteDocsRoute
          })
const SiteDocsSplatRoute = SiteDocsSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => SiteDocsRoute
          })





const SiteDocsRouteChildren = {
  SiteDocsSplatRoute: SiteDocsSplatRoute,SiteDocsIndexRoute: SiteDocsIndexRoute
}

const SiteDocsRouteWithChildren = SiteDocsRoute._addFileChildren(SiteDocsRouteChildren)



const SiteRouteChildren = {
  SiteSplatRoute: SiteSplatRoute,SiteAboutRoute: SiteAboutRoute,SiteContactRoute: SiteContactRoute,SiteDocsRoute: SiteDocsRouteWithChildren,SitePrivacyRoute: SitePrivacyRoute,SiteIndexRoute: SiteIndexRoute,SiteComponentsCategoryRoute: SiteComponentsCategoryRoute,SiteComponentsIndexRoute: SiteComponentsIndexRoute
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

const rootRouteChildren = {
  SiteRoute: SiteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)